import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { CartProvider } from './context/CartContext';
import { LoadingProvider } from './context/LoadingContext/LoadingContext';
import { NetworkProvider } from './components/common/NetworkError/NetworkError'; 
import Modal from 'react-modal';

//CSS
import './assets/styles/base.scss'; 

Modal.setAppElement('#root');

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
      <NetworkProvider>
        <LoadingProvider>
          <CartProvider>
            <App />
          </CartProvider>
        </LoadingProvider>
      </NetworkProvider>
  </React.StrictMode>
);